import { Icon, IconButton, IconButtonProps, Tooltip } from '@chakra-ui/react'
import { Minus } from 'lucide-react'

interface Props extends Omit<IconButtonProps, 'aria-label'> {}

const Component = ({ isLoading, onClick, ...props }: Props) => {
  return (
    <Tooltip label="Remover">
      <IconButton
        colorScheme="primary"
        aria-label="Remover"
        isLoading={isLoading}
        onClick={onClick}
        icon={<Icon as={Minus} />}
        {...props}
      />
    </Tooltip>
  )
}

export default Component
